import { useEffect, useState } from "react";
import { useAuthUser } from "./useAuthUser";
import {
  connectRealtimeSocket,
  disconnectRealtimeSocket,
} from "realtime/socketClient";

/**
 * Maintains a single Socket.io connection while the user is authenticated.
 */
export function useRealtimeSocket(): { connected: boolean } {
  const { token, user } = useAuthUser();
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!user?.user_id || !token) {
      disconnectRealtimeSocket();
      setConnected(false);
      return;
    }
    const s = connectRealtimeSocket(token);
    const onConnect = () => setConnected(true);
    const onDisconnect = () => setConnected(false);
    s.on("connect", onConnect);
    s.on("disconnect", onDisconnect);
    setConnected(s.connected);
    return () => {
      s.off("connect", onConnect);
      s.off("disconnect", onDisconnect);
    };
  }, [user?.user_id, token]);

  return { connected };
}
